<template>
	<page enable-flex>
		<view-list ref="view" work-type="3">
			<template #filter>
				<m-search>
					<m-search-item label="采购单号">
						<c-input name="purchase_code"></c-input>
					</m-search-item>
					<m-search-item label="快递单号">
						<c-input name="express_no"></c-input>
					</m-search-item>
					<m-search-item label="售卖人信息">
						<c-input name="seller_info"></c-input>
					</m-search-item>
					<m-search-item label="仓库">
						<c-select name="store_id" async @search="searchStore"></c-select>
					</m-search-item>
					<m-search-item label="创建时间">
						<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
					</m-search-item>
				</m-search>
			</template>

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #number>
						{{data.purchase_code}}
					</template>

					<template #state>
						<c-state dict="PURCHASE_ORDER_STATE" :value="data.purchase_state" type="state"></c-state>
					</template>

					<template #default>
						<c-field>
							<div class="flex" style="gap: .14rem;">
								<div class="flex" style="gap: .08rem;">
									<c-state color="#AD78CE" type="tag">收</c-state>
									<span style="color: #000;">{{data.purchase_product_count}}台</span>
								</div>
								<div class="flex" style="gap: .08rem;">
									<c-state color="#0078FF" type="tag">验</c-state>
									<span style="color: #000;">{{data.checked_count}}台</span>
								</div>
								<div class="flex" style="gap: .08rem;">
									<c-state color="#FF0000" type="tag">退</c-state>
									<span style="color: #000;">{{data.return_count}}台</span>
								</div>
							</div>
						</c-field>
						<c-field label="售卖人">{{data.seller_name}}</c-field>
						<c-field label="采购人">{{data.purchase_user_realname}}</c-field>
						<c-field label="创建部门">{{data.create_dept_name||'-'}}</c-field>
						<c-field label="采购总价"><span style="color: #FF6900;">￥{{data.purchase_money}}</span></c-field>
					</template>
					<template #operate>
						<c-button v-if="auth('b_app_purchase_online_view')" hollow @click="globalDialog('purchaseOrderDetail', {props: {orderId: data.id}})">详情</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		
		methods: {
			searchStore(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'STORE',
						keyword: keyword
					},
					success: data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>